import React from "react";
import {Button} from 'semantic-ui-react'
import FileUploadBtn from "./fileUploadBtn/index";
import FileReconBtn from "./fileBtn/index";
import { useSelector } from "react-redux";

const ButtonMapper = () => {
    const {currentJob: {reconShipmentStatus}} = useSelector((state) => state.currentJob)
    const [filingState, setFilingState] = React.useState();

    return ( <>
            {(reconShipmentStatus !== "Filed" && reconShipmentStatus !== "Completed") && <>
                <Button.Group style={{marginRight:'5px'}}>
                {!filingState &&
                        <FileUploadBtn />
                }
                </Button.Group>
                <Button.Group>
                        <FileReconBtn setFilingState={setFilingState} filingState={filingState} />
                </Button.Group>
            </>}
    </> );
}
 
export default ButtonMapper;